<template>
	<v-col v-if="concepts.length > 0" cols="12" class="pa-0">
		<v-expansion-panels variant="accordion">
			<v-expansion-panel v-for="(concept, index) in concepts" :key="index">
				<v-expansion-panel-title>
					<span class="font-weight-bold">{{ concept.name }}</span>
					<!-- Which EVS terminology this hit came from. Useful when the search
					     spans multiple ("All"); it also determines which Dactyl axis the
					     hit may be added as. -->
					<v-chip
						v-if="terminologyLabel(concept)"
						size="x-small"
						color="cyan-darken-2"
						variant="tonal"
						class="ml-2 my-n1"
					>
						{{ terminologyLabel(concept) }}
					</v-chip>
					<v-chip
						v-if="addedConcept(concept)"
						size="small"
						color="amber-darken-2"
						variant="tonal"
						class="ml-2 my-n1"
					>
						<v-icon start size="20">mdi-qrcode</v-icon>
						{{ addedConcept(concept).dactylConceptId }}
					</v-chip>
					<v-spacer />
					<v-btn
						v-if="addedConcept(concept)"
						size="small"
						variant="flat"
						class="mr-2 bg-provenance-b-tint text-provenance-b-ink"
						prepend-icon="mdi-pencil"
						@click.stop="$emit('edit', addedConcept(concept))"
					>
						Edit
					</v-btn>
					<v-btn
						v-else
						size="small"
						variant="flat"
						class="mr-2 bg-provenance-b-tint text-provenance-b-ink"
						prepend-icon="mdi-plus"
						@click.stop="$emit('add', concept)"
					>
						Add to Dactyl Concepts
					</v-btn>
				</v-expansion-panel-title>

				<v-expansion-panel-text>
					<v-card flat>
						<div v-if="concept.code" class="mb-1">
							<p class="text-body-2">
								<strong>Code: </strong>
								{{ concept.code }}
							</p>
						</div>

						<div v-if="concept.definitions?.length" class="mb-1">
							<p class="text-body-2">
								<strong>Definitions: </strong>
							</p>
							<ul class="pl-4">
								<li
									v-for="(def, i) in concept.definitions"
									:key="i"
									class="mb-2 text-body-2"
								>
									<span class="font-weight-bold">{{ def.source }}</span>
									: {{ def.definition }}
								</li>
							</ul>
						</div>

						<div v-if="concept.synonyms?.length">
							<p class="text-body-2">
								<strong>Synonyms: </strong>
							</p>
							<ul class="pl-4">
								<li
									v-for="(syn, i) in concept.synonyms"
									:key="i"
									class="mb-2 text-body-2"
								>
									<span class="font-weight-bold">{{ syn.source }}</span>
									: {{ syn.name }}
								</li>
							</ul>
						</div>
					</v-card>
				</v-expansion-panel-text>
			</v-expansion-panel>
		</v-expansion-panels>
	</v-col>
	<v-col v-else cols="12">
		<v-list>
			<v-list-item>
				<template #subtitle>
					<p class="text-body-2">
						{{ noResultsText }}
					</p>
				</template>
			</v-list-item>
		</v-list>
	</v-col>
</template>

<script>
export default {
	// Name matches the filename; it is registered as `EvsResultsList` in index.vue.
	name: "MetathesaurusResultsList",

	props: {
		concepts: { type: Array, default: () => [] },
		searchTerm: { type: String, default: "" },
		// Map of NCI CUI -> added Dactyl concept (from /concepts/list).
		conceptsByNci: { type: Object, default: () => ({}) },
	},

	emits: ["add", "edit"],

	computed: {
		noResultsText() {
			return this.searchTerm
				? `No NCI EVS results for search term ${this.searchTerm}`
				: "Enter a search term to search NCI EVS";
		},
	},

	methods: {
		// The Dactyl concept this NCI EVS concept has been added as, or undefined.
		addedConcept(concept) {
			return this.conceptsByNci[concept.code];
		},
		// Short uppercase label for a hit's source terminology (e.g. "MEDRT"), or "".
		terminologyLabel(concept) {
			return concept.terminology
				? String(concept.terminology).toUpperCase()
				: "";
		},
	},
};
</script>
